import type { WelcomeGalaxyGlyph } from "#welcome-galaxy-glyphs-types";
import welcomeGalaxyGlyphsData from "#welcome-galaxy-glyphs.gen.json" with { type: "json" };

/** Side of the square coordinate space every stroke path is drawn in. */
export const WELCOME_GALAXY_GLYPH_BOX: number = welcomeGalaxyGlyphsData.box;

/** The welcome galaxy's characters, most common first (see `_build-welcome-galaxy-glyphs.ts`). */
export const WELCOME_GALAXY_GLYPHS: readonly WelcomeGalaxyGlyph[] = welcomeGalaxyGlyphsData.glyphs;
